module.exports = __webpack_public_path__ + "img/Matt Macey.cbe646f0.png";